// removed by extract-text-webpack-plugin
module.exports = {"nf-button--gray-border":"nf-button--gray-border","nf-button--orange":"nf-button--orange"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ToolingManagement/ToolingManagement.scss
// module id = 5263
// module chunks = 1